import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  Input,
  FormLabel,
  Flex,
  Spinner,
  Textarea,
  useTheme,
  FormErrorMessage,
  Select,
} from "@chakra-ui/react";
import SubmitButton from "../../buttons/SubmitButton";
const AddSubTopicModal = ({ isOpen, onClose }) => {
  const theme = useTheme();
  const {
    placeholderOuterColor,
    placeholderTextColor,
    deleteBtnColor,
    primaryBlueLight,
    primaryBlue,
  } = theme.colors.pallete;
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"18px"} fontWeight={400} textAlign="center">
            Add Sub Topic
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl isRequired>
              <FormLabel>Chapter</FormLabel>
              <Select
                fontSize="14px"
                borderColor={placeholderOuterColor}
                placeholder="Select chapter"
              >
                <option value="chapter1">Chapter 1</option>
                <option value="chapter2">Chapter 2</option>
                <option value="chapter3">Chapter 3</option>
              </Select>
            </FormControl>

            <FormControl isRequired mt={4}>
              <FormLabel>Topic</FormLabel>
              <Select
                fontSize="14px"
                borderColor={placeholderOuterColor}
                placeholder="Select topic"
              >
                <option value="topic1">Topic 1</option>
                <option value="topic2">Topic 2</option>
                <option value="topic3">Topic 3</option>
              </Select>
            </FormControl>

            <FormControl isRequired mt={4}>
              <FormLabel>Name</FormLabel>
              <Input
                fontSize={"14px"}
                borderColor={placeholderOuterColor}
                _placeholder={{ color: placeholderTextColor }}
                placeholder="Enter subtopic name"
              />
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Description</FormLabel>
              <Textarea
                borderColor={placeholderOuterColor}
                _placeholder={{ color: placeholderTextColor }}
                fontSize={"14px"}
                placeholder="Enter Description"
              />
            </FormControl>

            <FormControl mt={4} isRequired>
              <FormLabel>Display Order</FormLabel>
              <Input
                fontSize={"14px"}
                borderColor={placeholderOuterColor}
                _placeholder={{ color: placeholderTextColor }}
                placeholder="Enter display order"
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Flex w={"full"} justifyContent={"center"}>
              <SubmitButton
                text={"Submit"}
                backColor={primaryBlue}
                textColor="white"
                hoverColor={primaryBlueLight}
              />
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddSubTopicModal;
